(function () {
    'use strict';

    angular.module("imApp").factory("metaTableViewService", ['$ihttp', function ($ihttp) {
        let service = {
            getMetaTableView: function (parms) {
                return $ihttp.post({
                    method: 2429,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2430,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 2431,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
